if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initProductCards();
  });
} else {
  initProductCards();
}

// Re-initialize for Shopify customizer events
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initProductCards();
  });
}

function initProductCards() {
  // 1. Wishlist Persistence & Actions
  let wishlist = [];
  try {
    const stored = localStorage.getItem('store_wishlist');
    if (stored) {
      wishlist = JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to parse wishlist from localStorage', e);
  }

  updateHeaderWishlistCount();

  const wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');
  wishlistButtons.forEach(btn => {
    const productId = btn.getAttribute('data-wishlist-toggle');
    
    // Initial active state setting
    if (wishlist.includes(productId)) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }

    // Toggle on click
    // Avoid double listener attaches
    if (!btn.dataset.listenerAttached) {
      btn.dataset.listenerAttached = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        let currentWishlist = [];
        try {
          const latestStored = localStorage.getItem('store_wishlist');
          if (latestStored) {
            currentWishlist = JSON.parse(latestStored);
          }
        } catch (err) {
          console.error(err);
        }

        const idx = currentWishlist.indexOf(productId);
        if (idx > -1) {
          currentWishlist.splice(idx, 1);
          btn.classList.remove('is-active');
        } else {
          currentWishlist.push(productId);
          btn.classList.add('is-active');
        }

        localStorage.setItem('store_wishlist', JSON.stringify(currentWishlist));
        updateHeaderWishlistCount();
        
        // Dispatch custom global event
        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: {
            wishlist: currentWishlist,
            productId: productId,
            action: idx > -1 ? 'removed' : 'added'
          }
        }));
      });
    }
  });

  // 2. AJAX Add to Cart Action
  const cartButtons = document.querySelectorAll('.product-card-custom__cart-btn');
  cartButtons.forEach(btn => {
    if (!btn.dataset.listenerAttached) {
      btn.dataset.listenerAttached = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute('data-cart-add-id');
        const handle = btn.getAttribute('data-product-handle');

        if (!variantId) {
          console.warn('No variant ID found on add to cart button.');
          return;
        }

        if (btn.classList.contains('loading')) return;
        btn.classList.add('loading');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart) {
          const sectionsToRender = cart.getSectionsToRender().map((section) => section.id).join(',');
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(btn);
        } else {
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Error adding to cart:', response.description || response.message);
            alert(response.description || response.message);
            return;
          }

          // Visual checkmark feedback
          const originalHTML = btn.innerHTML;
          btn.innerHTML = `
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#10b981" stroke-width="2.5">
              <polyline points="20 6 9 17 4 12" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          setTimeout(() => {
            btn.innerHTML = originalHTML;
          }, 2000);

          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card-custom',
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (response.sections && response.sections['cart-icon-bubble']) {
            updateCustomHeaderCartCount(response.sections['cart-icon-bubble']);

            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              const html = response.sections['cart-icon-bubble'];
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const sectionEl = doc.querySelector('.shopify-section');
              const innerHTML = sectionEl ? sectionEl.innerHTML : html;
              bubble.innerHTML = innerHTML;
            }
          }

          if (cart) {
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            cart.renderContents(response);
          }
        })
        .catch((err) => {
          console.error('Add to cart failed:', err);
        })
        .finally(() => {
          btn.classList.remove('loading');
        });
      });
    }
  });
}

function updateCustomHeaderCartCount(sectionsHtml) {
  if (!sectionsHtml) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionsHtml, 'text/html');
  const countBubble = doc.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  const count = countBubble ? parseInt(countBubble.textContent.trim()) : 0;

  if (count <= 0) {
    // Desktop
    const desktopBadge = document.querySelector('.custom-header__desktop-cart-count');
    if (desktopBadge) desktopBadge.remove();

    // Mobile
    const mobileBadge = document.querySelector('.custom-header__cart-count');
    if (mobileBadge) mobileBadge.remove();
    return;
  }

  // Update Desktop
  const desktopCart = document.getElementById('custom-cart-icon-desktop');
  if (desktopCart) {
    let desktopBadge = desktopCart.querySelector('.custom-header__desktop-cart-count');
    if (!desktopBadge) {
      desktopBadge = document.createElement('span');
      desktopBadge.className = 'custom-header__desktop-cart-count';
      desktopCart.appendChild(desktopBadge);
    }
    desktopBadge.textContent = count;
  }

  // Update Mobile
  const mobileCartIcon = document.getElementById('custom-cart-icon');
  if (mobileCartIcon) {
    const iconWrapper = mobileCartIcon.querySelector('.custom-header__icon-wrapper');
    if (iconWrapper) {
      let mobileBadge = iconWrapper.querySelector('.custom-header__cart-count');
      if (!mobileBadge) {
        mobileBadge = document.createElement('span');
        mobileBadge.className = 'custom-header__cart-count';
        iconWrapper.appendChild(mobileBadge);
      }
      mobileBadge.textContent = count;
    }
  }

  // Update Mobile Bottom Nav Cart
  const mobileBottomCart = document.getElementById('mobile-bottom-nav-cart');
  if (mobileBottomCart) {
    const iconWrapper = mobileBottomCart.querySelector('.custom-bottom-nav__icon-wrapper');
    if (iconWrapper) {
      let mobileBadge = iconWrapper.querySelector('.custom-header__cart-count');
      if (!mobileBadge) {
        mobileBadge = document.createElement('span');
        mobileBadge.className = 'custom-header__cart-count';
        // Match inline styles
        mobileBadge.style.position = 'absolute';
        mobileBadge.style.top = '-6px';
        mobileBadge.style.right = '-6px';
        mobileBadge.style.background = '#000';
        mobileBadge.style.color = '#fff';
        mobileBadge.style.borderRadius = '50%';
        mobileBadge.style.width = '16px';
        mobileBadge.style.height = '16px';
        mobileBadge.style.fontSize = '10px';
        mobileBadge.style.display = 'flex';
        mobileBadge.style.alignItems = 'center';
        mobileBadge.style.justifyContent = 'center';
        mobileBadge.style.fontWeight = '700';
        mobileBadge.style.lineHeight = '1';
        iconWrapper.appendChild(mobileBadge);
      }
      mobileBadge.textContent = count;
      mobileBadge.style.display = count > 0 ? 'flex' : 'none';
    }
  }
}

window.initProductCards = initProductCards;

// 3. Wishlist Page Dynamically Populating Logic
document.addEventListener('DOMContentLoaded', () => {
  const wishlistContainer = document.getElementById('custom-wishlist-container');
  if (wishlistContainer) {
    renderWishlistPage(wishlistContainer);
  }
});

// Re-run if Shopify customizer re-loads on the page
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const wishlistContainer = document.getElementById('custom-wishlist-container');
    if (wishlistContainer) {
      renderWishlistPage(wishlistContainer);
    }
  });
}

function renderWishlistPage(container) {
  let wishlist = [];
  try {
    const stored = localStorage.getItem('store_wishlist');
    if (stored) {
      wishlist = JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to load wishlist from localStorage:', e);
  }

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="wishlist-empty-state">
        <h2 class="wishlist-empty-title">Your wishlist is empty</h2>
        <p class="wishlist-empty-text">Add items you love to save them here!</p>
        <a href="/" class="wishlist-empty-btn">Continue Shopping</a>
      </div>
    `;
    return;
  }

  // Fetch product JSON details for each handle in parallel
  const fetches = wishlist.map(handle => 
    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error(`Product ${handle} not found`);
        return res.json();
      })
      .catch(err => {
        console.error(err);
        return null;
      })
  );

  Promise.all(fetches).then(products => {
    const validProducts = products.filter(p => p !== null);

    if (validProducts.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty-state">
          <h2 class="wishlist-empty-title">Your wishlist is empty</h2>
          <p class="wishlist-empty-text">Add items you love to save them here!</p>
          <a href="/" class="wishlist-empty-btn">Continue Shopping</a>
        </div>
      `;
      return;
    }

    // Render grid
    let gridHTML = '<div class="custom-wishlist-grid">';
    validProducts.forEach(product => {
      const onSale = product.compare_at_price > product.price;
      const discountPercent = onSale ? Math.round(((product.compare_at_price - product.price) * 100) / product.compare_at_price) : 0;
      
      const priceFormatted = formatMoney(product.price);
      const comparePriceFormatted = onSale ? formatMoney(product.compare_at_price) : '';

      const hasExpress = product.tags.some(tag => tag.toLowerCase() === 'express');
      const firstAvailableVariant = product.variants.find(v => v.available);
      const variantId = firstAvailableVariant ? firstAvailableVariant.id : '';

      const featuredImage = product.featured_image ? product.featured_image : '//theme/placeholder.png';
      const secondaryImage = product.images.length > 1 ? product.images[1] : '';

      gridHTML += `
        <div class="product-card-custom" data-product-id="${product.id}">
          <div class="product-card-custom__image-wrapper">
            <div class="product-card-custom__badges">
              ${onSale ? `<span class="product-card-custom__badge product-card-custom__badge--sale">-${discountPercent}%</span>` : ''}
            </div>

            <button type="button" 
                    class="product-card-custom__wishlist-btn is-active" 
                    aria-label="Remove from wishlist" 
                    data-wishlist-toggle="${product.handle}">
              <svg class="icon-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <a href="${product.url}" class="product-card-custom__image-link">
              <div class="product-card-custom__media">
                <img src="${featuredImage}" alt="${product.title}" loading="lazy" class="product-card-custom__image product-card-custom__image--primary">
                ${secondaryImage ? `<img src="${secondaryImage}" alt="${product.title}" loading="lazy" class="product-card-custom__image product-card-custom__image--secondary">` : ''}
              </div>
            </a>
          </div>

          <div class="product-card-custom__info">
            <div class="product-card-custom__price-wrapper">
              <div class="product-card-custom__price ${onSale ? 'product-card-custom__price--sale' : ''}">
                ${priceFormatted}
              </div>
              ${onSale ? `<div class="product-card-custom__price product-card-custom__price--compare">${comparePriceFormatted}</div>` : ''}
            </div>

            ${variantId ? `
              <button type="button" 
                      class="product-card-custom__cart-btn" 
                      aria-label="Quick Add to Cart" 
                      data-cart-add-id="${variantId}"
                      data-product-handle="${product.handle}">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="3" y1="6" x2="21" y2="6" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 10a4 4 0 0 1-8 0" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            ` : ''}
          </div>

          <div class="product-card-custom__meta">
            <span class="product-card-custom__vendor">${product.vendor}</span>
            <span class="product-card-custom__title">${product.title}</span>
          </div>

          ${hasExpress ? `
            <div class="product-card-custom__express-badge">
              <span class="product-card-custom__express-icon">
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path d="M14.68.162a.5.5 0 0 1 .22.582l-2.384 7.468 4.178 1a.5.5 0 0 1 .242.834l-9.373 9.649a.5.5 0 0 1-.824-.533l2.965-7.481-4.47-1.07a.5.5 0 0 1-.245-.831L14.062.247a.5.5 0 0 1 .617-.085M6.311 9.84l4.186 1.002a.5.5 0 0 1 .348.67L8.593 17.2l7.014-7.22-3.847-.921a.5.5 0 0 1-.36-.639l1.886-5.907z"/>
                </svg>
              </span>
              Express
            </div>
          ` : ''}
        </div>
      `;
    });
    gridHTML += '</div>';
    container.innerHTML = gridHTML;

    // Initialize triggers for the new cards
    initProductCards();
  });
}

function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return `Rs. ${amount}`;
}

// Fade out removed items on wishlist page instantly
document.addEventListener('wishlist:updated', (e) => {
  const { productId, action } = e.detail; // here productId is the handle
  const wishlistContainer = document.getElementById('custom-wishlist-container');
  if (action === 'removed' && wishlistContainer) {
    const card = wishlistContainer.querySelector(`.product-card-custom [data-wishlist-toggle="${productId}"]`)?.closest('.product-card-custom');
    if (card) {
      card.style.opacity = '0';
      card.style.transform = 'scale(0.9)';
      card.style.transition = 'all 0.3s ease';
      setTimeout(() => {
        card.remove();
        const remainingCards = wishlistContainer.querySelectorAll('.product-card-custom');
        if (remainingCards.length === 0) {
          renderWishlistPage(wishlistContainer); // Show empty state
        }
      }, 300);
    }
  }
  updateHeaderWishlistCount();
});

function updateHeaderWishlistCount() {
  let wishlist = [];
  try {
    const stored = localStorage.getItem('store_wishlist');
    if (stored) {
      wishlist = JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to parse wishlist for badge update', e);
  }

  const count = wishlist.length;

  const badges = document.querySelectorAll('.custom-header__wishlist-count');
  badges.forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

